import { Injectable } from '@angular/core';
import { blank } from '../shared/utils/common';

@Injectable({
  providedIn: 'root',
})
export class SplashScreenService {
  dismiss(): void {
    const screen = window['loading_screen'];

    if (blank(screen)) {
      return;
    }

    screen.finish();
  }
}